module.exports = __webpack_public_path__ + "static/media/bootstrap.00f7b58e.png";